var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 20,
    viewBox: "0 0 11 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.51 3.32003H10.39V0.14003C9.47975 0.045377 8.56516 -0.00135428 7.65 2.98641e-05C4.93 2.98641e-05 3.07 1.66003 3.07 4.70003V7.32003H0V10.88H3.07V20H6.75V10.88H9.81L10.27 7.32003H6.75V5.05003C6.75 4.00003 7.03 3.32003 8.51 3.32003Z",
    fill: "#FFF7F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.04a451a51297818da3de28218206ff5d.svg";
export { ForwardRef as ReactComponent };